import { fm } from 'Components/FormatMessage';
import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowSubHeader from 'Components/HistoryRowSubHeader';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { isNil } from 'Utility/ramdaReplacement';
import { newButton } from '../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'htt'>[] = [];
const HTT = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
}: IHistoryContext<IDocumentWithTypeV2<'htt'>>): React.JSX.Element => {
  const httDocument = filterDocumentsByType(documents, ['htt']).sort(sortDocumentsDescending).at(0);

  return (
    <React.Fragment>
      <HistoryRow
        headerText={fm('diagnosis.huntington.htt.title')}
        rowButton={
          startEdit
            ? newButton(
                'htt',
                startEdit(httDocument ?? {}, 'htt'),
                'general.edit',
                undefined,
                undefined,
                !isNil((httDocument ?? {})._lockedFor),
                undefined,
                undefined,
                httDocument,
              )
            : undefined
        }
        menuItems={editHistoryMenuItems(httDocument)}
      >
        <React.Fragment>
          <HistoryRowVerticalItem
            header={fm('general.date')}
            value={httDocument?.date ? formatPartialDate(httDocument.date) : ' - '}
          />
          <HistoryRowVerticalItem
            header={fm('diagnosis.huntington.htt.title')}
            value={
              httDocument?.status ? fm(`diagnosis.huntington.htt.opts.doneNotDoneUnknown.${httDocument.status}`) : ' - '
            }
          />
          {httDocument?.status === 'done' && (
            <React.Fragment>
              <HistoryRowSubHeader header={fm('diagnosis.huntington.htt.cagRepeatLengths')} />
              <HistoryRowVerticalItem
                header={fm('diagnosis.huntington.htt.allele', { alleleId: '1' })}
                value={httDocument.cagRepeatLengths?.[0]?.cagLength ?? '-'}
              />
              <HistoryRowVerticalItem
                header={fm('diagnosis.huntington.htt.whoseAllele')}
                value={
                  httDocument.cagRepeatLengths?.[0].lineage
                    ? fm(`diagnosis.huntington.htt.${httDocument.cagRepeatLengths[0].lineage}Allele`)
                    : '-'
                }
              />
              <HistoryRowVerticalItem
                header={fm('diagnosis.huntington.htt.allele', { alleleId: '2' })}
                value={httDocument.cagRepeatLengths?.[1]?.cagLength ?? '-'}
              />
              <HistoryRowSubHeader header={fm('diagnosis.huntington.htt.httHaplotype')} />
              <HistoryRowVerticalItem
                header={fm('diagnosis.huntington.htt.httHaplotype')}
                value={
                  httDocument.httHaplotype
                    ? httDocument.httHaplotype === 'other' && httDocument.httHaplotypeOther
                      ? httDocument.httHaplotypeOther
                      : fm(`diagnosis.huntington.htt.opts.httHaplotype.${httDocument.httHaplotype}`)
                    : ' - '
                }
              />
              <HistoryRowVerticalItem
                header={fm('diagnosis.huntington.htt.httHaplotypeAdditionalInformation')}
                value={httDocument.httHaplotypeAdditionalInformation ?? ' - '}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      </HistoryRow>
    </React.Fragment>
  );
};

export default HTT;
